/* eslint-disable */

import { useEffect, useState } from 'react'
import spark from '../../assets/PaymentGateway/spark.svg'
import tick from '../../assets/PaymentGateway/Frame 354190.svg'
import { Button } from '../../Components/ui/button'
import { useLocation, useNavigate } from 'react-router-dom'
import { useModal } from '../../hooks/use-modal-store'
import { post } from '../../http/restservice'
import { Input } from '../../Components/ui/input'
import { ChevronLeft, Landmark, ScanLine } from 'lucide-react'
import { messageModalState } from '../../store/Feedback'
import { useRecoilState, useRecoilValueLoadable, useSetRecoilState } from 'recoil'
import { BankDetails } from '../../store/AccountDetailsStore'
import MFBasketPaymentRequest from './MFBasketPaymentRequest'
import env from '../../env/env'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import { toCurrency } from '../../utils/CurrencyUtil'
import { MFTimeBasedBaskets } from '../../store/MFBasketsStore'
import { userDetailsState } from '../LoginState'
import {
  BankAccountItem,
  PaymentMethodCard,
} from '../../Components/MutualFunds/PaymentSelectionUI'

const MFBasketOneTimePayment = () => {
  const location = useLocation()
  const [userDetails] = useRecoilState(userDetailsState)
  const clientCode = userDetails ? userDetails?.uid?.split('-')[0] : location?.state?.paymentPayload?.clientCode
  const navigate = useNavigate()
  const { onOpen } = useModal()
  const { showError } = useErrorPopup()
  const [upiId, setUpiId] = useState(userDetails?.upiId || '')
  const [isLoading, setIsLoading] = useState(false)
  const setMessageModalState = useSetRecoilState(messageModalState)
  const bankDetailsLoadable = useRecoilValueLoadable(BankDetails)
  const bankDetails = bankDetailsLoadable.state === 'hasValue' ? bankDetailsLoadable.contents : {}
  const isBanksLoading = bankDetailsLoadable.state === 'loading'
  const isBanksError = bankDetailsLoadable.state === 'hasError'
  const [showPaymentRequestPopup, setShowPaymentRequestPopup] = useState(false)
  const [selectedOption, setSelectedOption] = useState('')
  const [paymentStep, setPaymentStep] = useState('method')
  const [bankQuery, setBankQuery] = useState('')
  const [selectedBank, setSelectedBank] = useState(null)
  const [responseString, setResponseString] = useState('')
  const [orderNo, setOrderNo] = useState([])
  const baskets = useRecoilValueLoadable(MFTimeBasedBaskets)

  const bankAccountsList = (() => {
    const accounts = []

    if (Array.isArray(bankDetails?.banks) && bankDetails?.banks.length > 0) {
      bankDetails.banks.forEach((bank) => {
        accounts.push({
          accountNo: bank.accountNo,
          bankName: bank.bankName,
          ifscCode: bank.ifscCode,
          accountHolderName: bank.accountHolderName || bankDetails?.accountHolderName,
        })
      })
    } else if (bankDetails?.accountNo) {
      accounts.push({
        accountNo: bankDetails.accountNo,
        bankName: bankDetails.bankName,
        ifscCode: bankDetails.ifscCode,
        accountHolderName: bankDetails.accountHolderName,
      })
    }

    return accounts
  })()

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [])

  useEffect(() => {
    const onPopState = () => {
      setPaymentStep('method')
    }
    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [])

  useEffect(() => {
    if (paymentStep !== 'details') return
    if (bankAccountsList.length === 1 && !selectedBank) {
      setSelectedBank(bankAccountsList[0].accountNo)
    }
  }, [paymentStep, bankDetailsLoadable.state, selectedBank, bankAccountsList.length])

  const handlePaymentMode = (option) => {
    if (option !== selectedOption) {
      setSelectedBank(null)
      setBankQuery('')
    }
    setSelectedOption(option)
  }

  const goToDetailsStep = () => {
    if (!selectedOption) return
    window.history.pushState({ fabitsPaymentStep: 'details' }, '')
    setPaymentStep('details')
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const handleHeaderBack = () => {
    if (paymentStep === 'details') {
      window.history.back()
      return
    }
    navigate(-1)
  }

  const paymentStatus = async (orders) => {
    try {
      const response = await post('/mutualfundservice/api/bseStar/mfUpload/paymentStatus', {
        clientCode,
        orderNo: orderNo[0],
        isBasketOrder: true,
      })

      if (response.isError) {
        setMessageModalState({
          message: response?.response?.message,
          severity: 'error',
        })
      }

      if (
        (!response.isError &&
          response.status === 'SUCCESS' &&
          response.data !== 'PAYMENT NOT INITIATED FOR GIVEN ORDER') ||
        response.data === 'APPROVED ( UPI )'
      ) {
        const filteredConstituents = orders.map((fund) => {
          const statusItem = baskets?.contents?.data?.find((el) => {
            return fund.schemeCode.toLowerCase() == el.bseSchemeCode.toLowerCase()
          })
          if (statusItem) {
            return {
              ...fund,
              ...statusItem,
            }
          }
        })

        setShowPaymentRequestPopup(false)

        onOpen('openBasketPopup', {
          severity: 'success',
          baskets: {
            basket1: filteredConstituents,
          },
        })
      }

      if (
        !response.isError &&
        response.status === 'SUCCESS' &&
        response.data === 'PAYMENT NOT INITIATED FOR GIVEN ORDER'
      ) {
        setShowPaymentRequestPopup(false)

        showError(
          'UPI Payment In Progress',
          'Payment In Progress. Your UPI transaction is being processed. Please wait for a few minutes.',
          () => navigate(-1),
        )
      }
    } catch (error) {
      console.log('🚀 ~ paymentStatus ~ error:', error)
    }
  }

  const oneTimeOrderPayment = async () => {
    try {
      setIsLoading(true)

      const orderNumber = location?.state?.paymentPayload?.orders
        ?.filter((order) => order?.status === 'SUCCESS')
        ?.map((order) => order?.orderNumber)

      setOrderNo(orderNumber)

      const totalAmount = location?.state?.paymentPayload?.orders?.reduce(
        (acc, order) => acc + Number(order.orderVal),
        0,
      )

      if (selectedOption === 'UPI' && !upiId) {
        showError('Missing UPI ID', 'Please enter a valid UPI ID to proceed.')
        setIsLoading(false)
        return
      }

      const payload = {
        orderNumber,
        totalAmount,
        clientCode,
      }

      if (selectedOption === 'UPI') {
        payload.upiId = upiId
        payload.modeOfPayment = 'UPI'
        payload.loopbackURL = ''
        payload.isFirstTimePaymentUsingUPI = userDetails?.upiId ? false : userDetails?.upiId === upiId ? false : true
      } else {
        payload.modeOfPayment = 'DIRECT'
        payload.loopbackURL = `${env.LOOPBACK_URL}dashboard/one-time-payment/status`
      }

      const response = await post('/mutualfundservice/api/bseStar/api/oneTimePayment', payload)

      setIsLoading(false)

      if (response.isError) {
        showError(
          selectedOption !== 'UPI' ? 'Payment Failed' : 'UPI Payment Failed',
          'Payment could not be processed at the moment. Please try later.',
          () => { },
        )
      }

      if ((response?.status === 'SUCCESS') & (selectedOption === 'UPI')) {
        setShowPaymentRequestPopup(true)
      }

      if (
        selectedOption !== 'UPI' &&
        payload.modeOfPayment !== 'UPI' &&
        response?.data?.responsestring
      ) {
        setResponseString(response?.data?.responsestring)
        localStorage.setItem(
          'basketPaymentStatusData',
          JSON.stringify({
            response: response?.data?.responsestring,
            clientCode,
            orderNo: orderNumber[0],
          }),
        )
        navigate('/dashboard/one-time-payment/status', {
          state: {
            response: response?.data?.responsestring,
            clientCode,
            orderNo: location?.state?.orderNumber,
          },
        })
      }

      if (response?.status === 'FAILURE') {
        showError(
          selectedOption !== 'UPI' ? 'Payment Failed' : 'UPI Payment Failed',
          response.data.responsestring,
          () => navigate(-1),
        )
      }

      if (response.isError) {
        showError(
          selectedOption !== 'UPI' ? 'Payment Failed' : 'UPI Payment Failed',
          response.data.responsestring,
          () => navigate(-1),
        )
      }
    } catch (error) {
      console.log('🚀 ~ placeOneTimeOrder ~ error:', error)
    }
  }

  const filteredBankAccounts = bankAccountsList.filter((bank) => {
    const query = bankQuery.trim().toLowerCase()
    if (!query) return true
    return (
      bank.bankName?.toLowerCase().includes(query) ||
      bank.accountHolderName?.toLowerCase().includes(query) ||
      bank.accountNo?.slice(-4)?.includes(query)
    )
  })
  const showBankSearch = selectedOption === 'NetBanking' && bankAccountsList.length > 2

  const detailsCopy = {
    UPI: {
      title: 'UPI Payment',
      subtitle: 'Select your bank account',
      cta: 'Continue to UPI',
    },
    NetBanking: {
      title: 'Select your bank',
      subtitle: 'Choose the linked account you will pay from',
      cta: 'Continue',
    },
  }[selectedOption] || {
    title: 'Payment',
    subtitle: 'Select an account',
    cta: 'Continue',
  }

  const canContinueDetails =
    selectedOption === 'UPI'
      ? Boolean(upiId?.trim()) && (bankAccountsList.length === 0 || Boolean(selectedBank))
      : bankAccountsList.length === 0 || Boolean(selectedBank)

  return (
    <>
      {responseString ? (
        <></>
      ) : (
        <>
          {showPaymentRequestPopup ? (
            <MFBasketPaymentRequest
              bankDetails={bankDetails}
              setShowPaymentRequestPopup={setShowPaymentRequestPopup}
              paymentStatus={paymentStatus}
            />
          ) : (
            <div className='bg-white fabits-payment-page'>
              <div className='min-h-screen fabits-payment-shell'>
                <button
                  type='button'
                  className='flex gap-x-1 items-center font-semibold cursor-pointer lg:py-2.5 p-4 bg-white fabits-payment-header w-full text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500'
                  onClick={handleHeaderBack}
                >
                  <ChevronLeft className='h-5 w-5' />
                  Payment
                </button>

                <div className='flex items-start justify-center w-full fabits-payment-body'>
                  <div className='w-full max-w-[360px] px-1 fabits-payment-panel'>
                    <h1 className='font-dm-sans text-base font-medium leading-6 text-center fabits-payment-kicker'>
                      Investment amount
                    </h1>
                    <p className='font-dm-sans text-[32px] font-semibold leading-[42px] tracking-[-0.04em] text-center mt-2 mb-8 fabits-payment-amount'>
                      ₹ {toCurrency(location?.state?.paymentPayload?.lumpsumAmount)}
                    </p>

                    {paymentStep === 'method' ? (
                      <div className='flex flex-col gap-4 fabits-payment-methods'>
                        <h2 className='font-dm-sans text-base font-semibold leading-6 text-left text-black-500'>
                          How would you like to pay?
                        </h2>

                        <div
                          role='radiogroup'
                          aria-label='How would you like to pay?'
                          className='flex flex-col gap-4'
                        >
                          <PaymentMethodCard
                            id='UPI'
                            selected={selectedOption === 'UPI'}
                            onSelect={handlePaymentMode}
                            icon={
                              <ScanLine
                                className={selectedOption === 'UPI' ? 'text-primary-500' : 'text-[#727272]'}
                              />
                            }
                            title='UPI'
                            supportingText='Fastest · Up to ₹1 Lakh'
                            showFastest
                            sparkIcon={spark}
                          />

                          <PaymentMethodCard
                            id='NetBanking'
                            selected={selectedOption === 'NetBanking'}
                            onSelect={handlePaymentMode}
                            icon={
                              <Landmark
                                className={
                                  selectedOption === 'NetBanking' ? 'text-primary-500' : 'text-[#727272]'
                                }
                              />
                            }
                            title='Net Banking'
                            supportingText='Higher payment limits'
                          />
                        </div>

                        <Button
                          disabled={!selectedOption}
                          className='w-full mt-4 py-3 px-4 rounded-[12px] bg-[#41558d] disabled:bg-primary-300 font-dm-sans text-[14px] font-medium leading-[20px] text-white fabits-payment-proceed'
                          onClick={goToDetailsStep}
                        >
                          Continue
                        </Button>
                      </div>
                    ) : (
                      <div className='flex flex-col gap-6 fabits-payment-methods'>
                        <div className='flex flex-col gap-1'>
                          <h2 className='font-dm-sans text-xl font-semibold leading-7 text-left fabits-payment-option-title text-black-500'>
                            {detailsCopy.title}
                          </h2>
                          <p className='font-dm-sans text-sm font-medium leading-5 text-black-300 fabits-payment-helper'>
                            {detailsCopy.subtitle}
                          </p>
                        </div>

                        {showBankSearch && (
                          <div>
                            <label htmlFor='bank-search' className='sr-only'>
                              Search bank
                            </label>
                            <Input
                              id='bank-search'
                              value={bankQuery}
                              onChange={(e) => setBankQuery(e.target.value)}
                              type='text'
                              placeholder='Search bank'
                              className='fabits-payment-upi-input'
                            />
                          </div>
                        )}

                        {isBanksLoading && (
                          <p className='font-dm-sans text-sm text-black-300 fabits-payment-helper'>
                            Loading linked bank accounts…
                          </p>
                        )}

                        {isBanksError && (
                          <p className='font-dm-sans text-sm text-error-600' role='alert'>
                            Unable to load bank accounts. Please try again.
                          </p>
                        )}

                        {!isBanksLoading && !isBanksError && bankAccountsList.length === 0 && (
                          <p className='font-dm-sans text-sm text-black-300 fabits-payment-helper' role='status'>
                            No linked bank accounts found.
                          </p>
                        )}

                        {!isBanksLoading && bankAccountsList.length > 0 && (
                          <div role='radiogroup' aria-label='Select bank account' className='flex flex-col gap-3'>
                            {filteredBankAccounts.length === 0 ? (
                              <p className='font-dm-sans text-sm text-black-300 fabits-payment-helper'>
                                No banks match your search.
                              </p>
                            ) : (
                              filteredBankAccounts.map((bank) => (
                                <BankAccountItem
                                  key={bank.accountNo}
                                  bank={bank}
                                  isSelected={selectedBank === bank.accountNo}
                                  onSelect={setSelectedBank}
                                  tickIcon={tick}
                                  bankLogosUrl={env.BANK_LOGOS}
                                />
                              ))
                            )}
                          </div>
                        )}

                        {selectedOption === 'UPI' && (
                          <div className='flex flex-col gap-2'>
                            <label
                              htmlFor='upi-id'
                              className='font-dm-sans text-[14px] font-medium leading-[20px] text-black-500 fabits-payment-label'
                            >
                              UPI ID
                            </label>
                            <Input
                              id='upi-id'
                              value={upiId}
                              onChange={(e) => setUpiId(e.target.value)}
                              type='text'
                              placeholder='address@bank'
                              autoComplete='off'
                              className='fabits-payment-upi-input'
                              aria-describedby='upi-limit-note'
                            />
                            <p
                              id='upi-limit-note'
                              className='font-dm-sans text-sm font-medium leading-5 text-black-300 fabits-payment-note'
                            >
                              Some banks may have lower transaction limits. If UPI fails, you can switch to Net Banking.
                            </p>
                          </div>
                        )}

                        <Button
                          disabled={!canContinueDetails}
                          loading={isLoading}
                          className='w-full mt-2 py-3 px-4 rounded-[12px] bg-[#41558d] disabled:bg-primary-300 font-dm-sans text-[14px] font-medium leading-[20px] text-white fabits-payment-proceed'
                          onClick={() => oneTimeOrderPayment()}
                        >
                          {detailsCopy.cta}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}

export default MFBasketOneTimePayment
